const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

const asyncLaunch = (callback: () => Promise<void>) => callback();

const runner = () => {
  let started = true;

  async function* interval(callback: () => Promise<void>, ms: number) {
    while (started) {
      yield await callback();
      await sleep(ms);
    }
  }

  const waitInterval = async (callback: () => Promise<void>, ms: number): Promise<void> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for await (const _ of interval(callback, ms)) {
      /* empty */
    }
  };

  const start = ({
    duration,
    pool,
  }: {
    duration: number;
    pool: Map<string, () => Promise<void>>;
  }) => {
    started = true;

    setTimeout(
      () =>
        waitInterval(async () => {
          await Promise.allSettled([...pool.values()].map(asyncLaunch));
        }, duration),
      0,
    );
  };

  const stop = () => (started = false);

  return {
    start,
    stop,
  };
};

export class Poll {
  readonly #pool: Map<string, () => Promise<void>>;
  readonly #duration: number;
  readonly runner = runner();

  private constructor(duration: number) {
    this.#pool = new Map();
    this.#duration = duration;
  }

  static of(duration: number): Poll {
    return new Poll(duration);
  }

  set(id: string, callback: () => Promise<void>) {
    this.#pool.set(id, () => callback().catch(() => this.remove(id)));
  }

  remove(id: string) {
    this.#pool.delete(id);
  }

  run() {
    this.runner.start({
      duration: this.#duration,
      pool: this.#pool,
    });
  }

  stop() {
    this.runner.stop();
  }
}
